// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3a277f68","455":"11983788","977":"c7625621"}[chunkId] + ".chunk.js";
};